import { render, staticRenderFns } from "./paperEditDialog.vue?vue&type=template&id=261589bb&scoped=true&"
import script from "./paperEditDialog.vue?vue&type=script&lang=js&"
export * from "./paperEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./paperEditDialog.vue?vue&type=style&index=0&id=261589bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261589bb",
  null
  
)

export default component.exports